<template>
    <v-container fluid style="min-height:100vh">
        <v-row v-if="episodes">
            <v-col cols="12" sm="12" lg="7" class="ma-auto">
                <v-container>
                    <v-row class="">
                        <v-col class="pb-0">
                            <h1 class="" v-if="$vuetify.breakpoint.mdAndUp">Listen to Fred Dope RaveCast</h1>
                            <h1 style="text-align:center" v-else>Listen to Fred Dope RaveCast</h1>
                            <h3 class="mt-4 mb-4"><i>Your best source for the best EDM
                                in the scene! Carefully mixed and selected for you by Fred Dope</i></h3>
                        </v-col>
                    </v-row>
                    <v-row class="">
                                    <v-col xl="3" md="4" sm="12" xs="11" class="" align-self="end">
                                        <a href="https://podcasts.apple.com/us/podcast/fred-dope-ravecast/id855126677">
                                            <v-img src="@/assets/apple-podcasts.png"
                                                height="100" contain alt="Apple Podcasts" />
                                        </a>
                                    </v-col>
                                    <v-col xl="3" md="4" sm="12" xs="12" class="" align-self="end">
                                        <a href="https://podcasts.google.com/feed/aHR0cDovL2ZlZWRzLmZlZWRidXJuZXIuY29tL0ZyZWREb3BlUmF2ZWNhc3Q">
                                            <v-img src="@/assets/google-podcasts.png"
                                                height="100" contain alt="Google Podcasts" />
                                        </a>
                                    </v-col>
                                    <v-col xl="3" md="4" sm="12" xs="12" class=""  align-self="end">
                                        <a href="https://tunein.com/podcasts/Music-Podcasts/Fred-Dope-RaveCast-p1341732/?topicId=301435004">
                                            <v-img src="@/assets/tunein-podcasts.png"
                                                height="100" contain alt="TuneIN" />
                                        </a>
                                    </v-col>
                                </v-row>
                    <v-row class="">
                        <v-col cols="12" class="mt-0 mb-0">
                            <v-row>
                                <v-col :class="{'text-center': $vuetify.breakpoint.smAndDown}">
                                    <b>Latest Episode:</b>
                                    {{ episodes.title._text }} released on {{ episodes.pubDate._text | moment('DD/MM/YYYY')}}
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="mt-0 pt-0">
                            <v-row>
                                <v-col>
                                    <v-expansion-panels accordion>
            <v-expansion-panel>
  <v-expansion-panel-header>
    <span><b>Show Tracklist</b></span>
  </v-expansion-panel-header>
  <v-expansion-panel-content class=""> 
    <v-row>
        <v-col v-html=tracklist>
        </v-col>
    </v-row>
  </v-expansion-panel-content>
            </v-expansion-panel>
                                    </v-expansion-panels>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
            <v-col lg="5" sm="12" v-if="$vuetify.breakpoint.lgAndUp">
                <iframe id="embedPlayer" src="https://embed.podcasts.apple.com/us/podcast/fred-dope-ravecast/id855126677?itsct=podcast_box_player&amp;itscg=30200&amp;ls=1&amp;theme=dark" height="450px" frameborder="0" sandbox="allow-forms allow-popups allow-same-origin allow-scripts allow-top-navigation-by-user-activation" allow="autoplay *; encrypted-media *; clipboard-write" style="width: 95%;  overflow: hidden; border-radius: 10px; transform: translateZ(0px); animation: 2s ease 0s 6 normal none running loading-indicator; background-color: rgb(228, 228, 228);"></iframe>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
    name: 'RaveCast',
    data () {
        return {
            episodes: '',
            tracklist: ''
        }
    },
        beforeRouteEnter (from, to, next) {
        next(vm => {
        vm.$store.dispatch('setLoading', {variable: 'ravecast', value: true}).then(() => {
        vm.$axios.get(vm.$podcast).then(response => {
        var convert = response.data.toString("utf8")
        convert.replace(/d:|D:|lp1:/g, "");
        convert.replace(/\r?\n|\r/g, "");
        var object = JSON.parse(vm.$xml2json(convert, {compact: true, spaces: 4}))
        vm.episodes = object.rss.channel.item[0]
        vm.tracklist = (vm.episodes['content:encoded']._cdata).slice(0,(vm.episodes['content:encoded']._cdata).indexOf('</p>'))
        vm.$store.dispatch('setLoading', {variable: 'ravecast', value: false})
        }).catch((error) => console.log(error))
        })
        })
   },
   methods: {
       scrollToBottom () {
           window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
       }
   }
}
</script>
<style scoped>
.download-btn {
    max-width: 250px;
    display: inline-block;
    padding-bottom: 10px;
    color: #000;
    position: relative;
}
.scroller {
    overflow-y: scroll;
}
#style-1::-webkit-scrollbar
{
	width: 15px;
	background-color: #F5F5F5;
}

#style-1::-webkit-scrollbar-thumb
{
	border-radius: 10px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
}
.arrow {
    width: 100%;
    transform: scaleY(1);
}
.arrow-flip {
    width: 100%;
    transform: scaleY(-1);
}
.resized {
    width: 50%!important;
}
.image-container {
    text-align: center;
}

@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (-webkit-min-device-pixel-ratio: 1) {
    .image-container {
        display: none;
    }
}

</style>